import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

import NotFoundPage from '../../components/home/NotFoundPage';
import newInsureTab from './newInsureTab';
import OpdBenefits from './OpdBenefits';
import IpdBenefits from './IpdBenefits';
import faq from './QaPage';
import QaPage from './QaPage';

const InsureTabNavigator = ({ loginState, authToken, history }) => {
  if (loginState !== 'LOGGED_IN' || !authToken) {
    history.push('/');
    return false;
  }
  return (
    <Switch>
      <Route path="/home/insure" exact component={newInsureTab} />
      <Route path="/home/insure/opd-benefits" exact component={OpdBenefits} />
      <Route path="/home/insure/ipd-benefits" exact component={IpdBenefits} />
      <Route path="/home/insure/faq" exact component={QaPage} />
      <Route path="*" component={NotFoundPage} />
    </Switch>
  );
};

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  loginState: state.app.loginState,
});

export default connect(mapStateToProps)(InsureTabNavigator);
